import React, { FC, useEffect, useState } from 'react'
import { RootState, useAppSelector } from '../../utils/agent.store'
import { isEmpty } from 'lodash'
import { getEntityDataByIdEmbedded } from '../../apis/entityData.api'
import SendManualCommunication from '../send-manual-communication/SendManualCommunication'
import { SendCommunicationTaskPropsType } from '../../types/workflow.types'
import {
  SEND_MANUAL_COMMUNICATION_CONSTANT,
  WORKFLOW_UI_IDENTIFIER,
} from '@app-store'
import FaxOutboundTask from '../send-manual-communication/FaxOutboundTask'
import GenerateDocumentTask from './GenerateDocumentTask'
import { ENTITY_FIELDS } from '../../utils/constants'
import { isReadOnlyUser } from '../../utils/permission'
import { permissionObject } from '../../utils/helperFunctions'
import OutboundTask from '../send-manual-communication/OutboundTask'

const SendCommunicationTask: FC<SendCommunicationTaskPropsType> = ({
  recordId,
  task,
  updateTaskResource,
  tabIndexOffset,
  isDisabled,
  workFlowUiIdentifier,
  isAutoTask = false,
  refetch,
  createTask,
}) => {
  if (task?.identifier?.template?.id) {
    task = {
      ...task,
      identifier: {
        ...task.identifier,
        template_id: task.identifier.template?.id,
      },
    }
  }
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions?.programPermissions
  )
  const caseData = useAppSelector(
    (state: RootState) => state.workflowData?.caseData
  )
  const userId = useAppSelector((state: RootState) => state?.authUser?.user?.id)

  const [faxRecord, setFaxRecord] = useState({
    communicationId: null,
    programId: null,
    serviceId: null,
    productId: null,
  })

  const [docRecord, setDocRecord] = useState({
    programName: null,
    serviceName: null,
    productName: null,
  })

  const relationshipTree = useAppSelector(
    (state) => state?.workflowData?.relationshipTree
  )
  const workflowDefinition = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const fetchInfo = async () => {
    try {
      // TODO: Communication Entity key change
      // const communicationEntityId =
      //   workflowDefinition?.global_variables?.entities?.communication?.entity_id

      // const communicationEntity = relationshipTree?.find(
      //   (item) =>
      //     item?.entity_id?.toString() === communicationEntityId?.toString()
      // )
      const programEntity = relationshipTree?.find(
        (item) =>
          item?.entity_id?.toString() ===
          workflowDefinition?.global_variables?.entities?.program?.entity_id
      )
      const serviceEntity = relationshipTree?.find(
        (item) =>
          item?.entity_id?.toString() ===
          workflowDefinition?.global_variables?.entities?.service?.entity_id
      )
      // if (!isEmpty(communicationEntity) && !isEmpty(programEntity)) {
      if (!isEmpty(programEntity)) {
        const response = await getEntityDataByIdEmbedded(
          workflowDefinition?.global_variables?.entity_name ?? '',
          Number(workflowDefinition?.global_variables?.entity_id),
          [
            // communicationEntity?.field_name ?? '',
            ENTITY_FIELDS?.case?.communication ?? '',
            programEntity?.field_name ?? '',
            serviceEntity?.field_name ?? '',
            SEND_MANUAL_COMMUNICATION_CONSTANT.PRODUCT_ENTITY_NAME,
          ],
          Number(recordId)
        )
        if (response?.data) {
          setFaxRecord({
            communicationId:
              // response?.data?.[communicationEntity?.field_name ?? '']?.[0]?.id,
              response?.data?.[ENTITY_FIELDS?.case?.communication ?? '']?.[0]
                ?.id,
            programId: response?.data?.[programEntity?.field_name ?? '']?.id,
            serviceId: response?.data?.[serviceEntity?.field_name ?? '']?.id,
            productId:
              response?.data?.[
                SEND_MANUAL_COMMUNICATION_CONSTANT.PRODUCT_ENTITY_NAME
              ]?.id,
          })
          setDocRecord({
            programName:
              response?.data?.[programEntity?.field_name ?? '']
                ?.operational_program_name,
            serviceName:
              response?.data?.[serviceEntity?.field_name ?? '']?.service_name,
            productName:
              response?.data?.[
                SEND_MANUAL_COMMUNICATION_CONSTANT.PRODUCT_ENTITY_NAME
              ]?.trademarked_name,
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const hasManagePermission = () => {
    return permissionObject.Manage_Workflow(
      programPermissions,
      caseData,
      task,
      userId ?? ''
    )
  }

  useEffect(() => {
    if (relationshipTree && workflowDefinition) fetchInfo()
  }, [relationshipTree, workflowDefinition])

  if (!faxRecord?.programId) return null

  if (
    workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.FAX_OUTBOUND_TASK ||
    workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.SYSTEM_MAIL_OUTBOUND ||
    workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.MANUAL_MAIL_OUTBOUND ||
    workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.SEND_COMMUNICATION_FAX ||
    workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK
  ) {
    return (
      <FaxOutboundTask
        task={task}
        programId={faxRecord.programId}
        serviceId={faxRecord.serviceId ?? ''}
        productId={faxRecord.productId ?? ''}
        caseId={recordId}
        sendServiceId={task?.identifier?.service_id ?? ''}
        preSelectedTemplateId={Number(task?.identifier?.template_id ?? '')}
        updateTaskResource={updateTaskResource}
        tabIndexOffset={tabIndexOffset}
        isDisabled={isReadOnlyUser() || isDisabled || !hasManagePermission()}
      />
    )
  }

  if (workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER?.MANUAL_TEXT_OUTBOUND) {
    return (
      <OutboundTask
        task={task}
        programId={faxRecord.programId}
        serviceId={faxRecord.serviceId ?? ''}
        productId={faxRecord.productId ?? ''}
        caseId={recordId}
        sendServiceId={task?.identifier?.service_id ?? ''}
        preSelectedTemplateId={Number(task?.identifier?.template_id ?? '')}
        updateTaskResource={updateTaskResource}
        tabIndexOffset={tabIndexOffset}
        isDisabled={isReadOnlyUser() || isDisabled || !!task?.resource_id}
      />
    )
  }

  if (workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER?.MANUAL_TEXT_OUTBOUND) {
    return (
      <OutboundTask
        task={task}
        programId={faxRecord.programId}
        serviceId={faxRecord.serviceId ?? ''}
        productId={faxRecord.productId ?? ''}
        caseId={recordId}
        sendServiceId={task?.identifier?.service_id ?? ''}
        preSelectedTemplateId={Number(task?.identifier?.template_id ?? '')}
        updateTaskResource={updateTaskResource}
        tabIndexOffset={tabIndexOffset}
        isDisabled={isReadOnlyUser() || isDisabled}
      />
    )
  }

  if (workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER?.GENERATE_DOCUMENT) {
    return (
      <GenerateDocumentTask
        task={task}
        programId={docRecord.programName ?? ''}
        serviceId={docRecord.serviceName ?? ''}
        productId={docRecord.productName ?? ''}
        caseId={recordId}
        sendServiceId={task?.identifier?.service_id ?? ''}
        preSelectedTemplateId={Number(task?.identifier?.template_id ?? '')}
        updateTaskResource={updateTaskResource}
        tabIndexOffset={tabIndexOffset}
        isDisabled={isReadOnlyUser() || isDisabled || !hasManagePermission()}
      />
    )
  }

  return (
    <SendManualCommunication
      task={task}
      programId={faxRecord.programId}
      serviceId={faxRecord.serviceId ?? ''}
      productId={faxRecord.productId ?? ''}
      caseId={recordId}
      sendServiceId={task?.identifier?.service_id ?? ''}
      preSelectedTemplateId={Number(task?.identifier?.template_id ?? '')}
      updateTaskResource={updateTaskResource}
      tabIndexOffset={tabIndexOffset}
      isDisabled={
        isReadOnlyUser() ||
        isDisabled ||
        !!task?.resource_id ||
        !hasManagePermission()
      }
      isAutoTask={isAutoTask}
      isAutoSms={
        workFlowUiIdentifier ===
        WORKFLOW_UI_IDENTIFIER?.AUTO_SEND_COMMUNICATION_SMS
      }
      refetch={refetch}
      createTask={createTask}
    />
  )
}

export default SendCommunicationTask
